import React from 'react'
import { useContainerWidth, Paragraph } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { useTranslation, Trans } from 'react-i18next'
import { buildUrl } from '../../footerHelperFunctions'

export default function TagLine({ nonReligiousMode, external }) {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()
  const showText = atWidth({ default: false, xs: true })

  if (!showText) {
    return null
  }
  return (
    <Paragraph size="xs" data-full-width>
      {atWidth({
        lg: (
          <>
            {t(
              'FooterExpansionContent.tagline.firstLine',
              'Inspiring people everywhere to connect with their family-across generations.'
            )}
            <br />
          </>
        ),
      })}
      {nonReligiousMode ? (
        t(
          'FooterExpansionContent.tagline.secondLineUnlinked',
          'FamilySearch is an international nonprofit organization. Donate or volunteer today!'
        )
      ) : (
        <Trans
          i18nKey="FooterExpansionContent.tagline.secondLine"
          defaults="FamilySearch is an international nonprofit organization. <0>Donate</0> or <1>volunteer</1> today!"
          components={[
            <Link
              key="footer.donate"
              to="https://philanthropies.churchofjesuschrist.org/church-general-fund/"
              external
              linkName="footer.donate"
              wayfinding
            />,
            <Link
              key="footer.volunteer"
              to={buildUrl('/info/volunteer', external)}
              external
              linkName="footer.volunteer"
              wayfinding
            />,
          ]}
        />
      )}
    </Paragraph>
  )
}
